export const GRENER = ["fotball", "håndball", "svømming", "turn", "sykkel", "ski", "basket", "volleyball", "boksing", "tennis", "badminton"];
export const STORE_LABELS = { ROYKEN: "Røyken", SLEMMESTAD: "Slemmestad" };
export const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
